/*
 * Which stage a release is at (the `stage` field in data/songs.js):
 *   "hidden"    not on the site at all (no card, no page); the data stays
 *   "teaser"    hidden cover, COMING SOON, "Arriving <year>"
 *   "announced" real title, cover and preview; streaming buttons off until
 *               releaseDate
 *   "released"  everything on (also when `stage` is left out)
 * An announced release counts as released from its releaseDate on (without a
 * releaseDate it stays announced, showing "Coming soon" instead of a date). The check
 * uses the visitor's own date, so the buttons switch on at their midnight on
 * release day, with no new deploy.
 */
const pad = (n) => String(n).padStart(2, "0");

// Today as "YYYY-MM-DD" in the visitor's time zone
export const today = () => {
  const now = new Date();
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};

export const stageOf = (release) => {
  if (release.stage === "hidden") return "hidden";
  if (release.stage === "teaser") return "teaser";
  if (release.stage === "announced" && !(release.releaseDate <= today())) return "announced";
  return "released";
};

export const isHidden = (release) => stageOf(release) === "hidden";

/*
 * The COMING SOON teaser: only one at a time, at a fixed public address
 * (thangcao.me/soon), so its real address (which is usually its title) isn't
 * given away. While it's a teaser, its real address leads to the home page.
 * If songs.js has more than one teaser, only the first one is shown.
 */
export const TEASER_PATH = "soon";
export const currentTeaserKey = (songs) =>
  Object.keys(songs).find((key) => stageOf(songs[key]) === "teaser") || null;
export const isTeaser = (release) => stageOf(release) === "teaser";
export const isOut = (release) => stageOf(release) === "released";

// When an announced release comes out, as "Coming 20.11" (DD.MM), with the
// year only when it isn't this year ("Coming 15.01.2027"). Used on the song
// page and the home page badge. Without a releaseDate yet: "Coming soon".
export const outLabel = (release, word = "Coming") => {
  if (!release.releaseDate) return "Coming soon";
  const [year, month, day] = release.releaseDate.split("-");
  const thisYear = String(new Date().getFullYear());
  return `${word} ${day}.${month}${year === thisYear ? "" : `.${year}`}`;
};
